import request from '@/config/axios'

export interface CatalogCategoryVO {
  id?: number
  parentId?: number
  categoryCode?: string
  name?: string
  icon?: string
  level?: number
  sort?: number
  flowModel?: string
  flowModelName?: string
  priceType?: string
  payType?: string
  fieldsConfig?: string
  orderImagesMode?: 'OFF' | 'OPTIONAL' | 'REQUIRED'
  orderImagesMin?: number
  orderImagesMax?: number
  orderImagesTip?: string
  cancelRules?: string
  certRequirements?: string
  specialRules?: string
  packageEnabled?: boolean
  periodEnabled?: boolean
  c08Template?: string
  c10Template?: string
  status?: string
  remark?: string
  leaf?: boolean
  childCount?: number
  serviceCount?: number
  deletable?: boolean
  deleteBlockReason?: string
  publishedServiceCount?: number
  flowConfigLocked?: boolean
  flowConfigLockReason?: string
  statusName?: string
  children?: CatalogCategoryVO[]
}

export const CatalogCategoryApi = {
  getTree: async () => {
    return await request.get({ url: '/o2o/catalog/category/tree' })
  },
  get: async (id: number) => {
    return await request.get({ url: '/o2o/catalog/category/get?id=' + id })
  },
  create: async (data: CatalogCategoryVO) => {
    return await request.post({ url: '/o2o/catalog/category/create', data })
  },
  update: async (data: CatalogCategoryVO) => {
    return await request.put({ url: '/o2o/catalog/category/update', data })
  },
  delete: async (id: number) => {
    return await request.delete({ url: '/o2o/catalog/category/delete?id=' + id })
  },
  publish: async (data: { id: number; status: string }) => {
    return await request.put({ url: '/o2o/catalog/category/publish', data })
  },
  updateSort: async (data: { items: { id: number; sort: number }[] }) => {
    return await request.put({ url: '/o2o/catalog/category/update-sort', data })
  }
}
